import { render, staticRenderFns } from "./WoodType.vue?vue&type=template&id=6aa21f9b"
import script from "./WoodType.vue?vue&type=script&lang=js"
export * from "./WoodType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports